export default "__VITE_ASSET__CdHDRaTS__"